import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const ReportIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-report${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M5.33329 3.33334H3.99996C3.64634 3.33334 3.3072 3.47381 3.05715 3.72386C2.8071 3.97391 2.66663 4.31305 2.66663 4.66667V12.6667C2.66663 13.0203 2.8071 13.3594 3.05715 13.6095C3.3072 13.8595 3.64634 14 3.99996 14H7.79796"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 9.33333V12H14.6667"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7.33334V4.66667C12 4.31305 11.8596 3.97391 11.6095 3.72386C11.3595 3.47381 11.0203 3.33334 10.6667 3.33334H9.33337"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33337 3.33333C5.33337 2.97971 5.47385 2.64057 5.7239 2.39052C5.97395 2.14048 6.31309 2 6.66671 2H8.00004C8.35366 2 8.6928 2.14048 8.94285 2.39052C9.1929 2.64057 9.33337 2.97971 9.33337 3.33333C9.33337 3.68696 9.1929 4.02609 8.94285 4.27614C8.6928 4.52619 8.35366 4.66667 8.00004 4.66667H6.66671C6.31309 4.66667 5.97395 4.52619 5.7239 4.27614C5.47385 4.02609 5.33337 3.68696 5.33337 3.33333Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33337 12C9.33337 12.7072 9.61433 13.3855 10.1144 13.8856C10.6145 14.3857 11.2928 14.6667 12 14.6667C12.7073 14.6667 13.3856 14.3857 13.8857 13.8856C14.3858 13.3855 14.6667 12.7072 14.6667 12C14.6667 11.2928 14.3858 10.6145 13.8857 10.1144C13.3856 9.61428 12.7073 9.33333 12 9.33333C11.2928 9.33333 10.6145 9.61428 10.1144 10.1144C9.61433 10.6145 9.33337 11.2928 9.33337 12Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33337 7.33333H8.00004"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33337 10H7.33337"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default ReportIcon;
